import { Button, Col, Flex, Row } from "antd";
import CustomTitle from "../../../components/CustomTitle";
import StateCard from "../../../components/StateCard";
import DashboardLayout from "../../../layouts/DashboardLayout";

import { useNavigate } from "react-router";
import { useAppSelector } from "../../../app/app.store";
import CoursesIcon from "../../../assets/icons/CoursesIcon";
import RoundUserIcon from "../../../assets/icons/RoundUserIcon";
import WalletIcon from "../../../assets/icons/WalletIcon";
import WithdrawIcon from "../../../assets/icons/WithdrawIcon";
import SalesStatistics from "./_components/SalesStatistics";
import TopPlaces from "./_components/TopPlaces";
import TopSellingCourse from "./_components/TopSellingCourse";

const Dashboard = () => {
  const navigate = useNavigate();
  const { employee } = useAppSelector((state) => state.auth);

  return (
    <DashboardLayout title="Dashboard">
      <Flex justify="space-between" align="center" className="mb-4">
        <CustomTitle
          title={`Welcome Back, ${employee?.fullName}!`}
          description="Your teaching insights and updates are ready."
        />

        <Button
          type="primary"
          onClick={() => navigate(`/admin/my-course/manage-course`)}
          className="shadow-sm"
        >
          Create New Course
        </Button>
      </Flex>

      <Row gutter={[16, 16]}>
        <Col span={6}>
          <StateCard
            icon={<WalletIcon className="text-[#F59E0B] text-2xl" />}
            title="Total Earnings"
            count={`৳12,540`}
            iconClass="bg-orange-100"
          />
        </Col>
        <Col span={6}>
          <StateCard
            icon={<WithdrawIcon className="text-[#2497EB] text-2xl" />}
            title="Ready to Withdraw"
            count={`৳6,540`}
            iconClass="bg-sky-100"
          />
        </Col>
        <Col span={6}>
          <StateCard
            icon={<RoundUserIcon className="text-[#4C56BB] text-2xl" />}
            title="Total Enrollments"
            count={`25K`}
            iconClass="bg-indigo-100"
          />
        </Col>
        <Col span={6}>
          <StateCard
            icon={<CoursesIcon className="text-[#0A9952] text-2xl" />}
            title="Active Courses"
            count={`3`}
            iconClass="bg-green-100"
          />
        </Col>
      </Row>

      <Row gutter={[16, 16]} className="mt-4">
        <Col span={14}>
          <SalesStatistics />
        </Col>
        <Col span={10}>
          <TopPlaces />
        </Col>
      </Row>

      <TopSellingCourse />
    </DashboardLayout>
  );
};

export default Dashboard;
